import React from 'react';

import { CSSInterpolation } from '@emotion/css/create-instance';
import { css } from '@emotion/react';
import { ExtendedPaletteColorName, Icon24, Type, ValuePropRow } from '@robinhood/design';

import Cell from 'src/components/creditApplication/Cell';
import Divider from 'src/components/creditApplication/Divider';
import { GoldGradient } from 'src/constants/theme';

interface RowPropsIface {
  icon: Icon24;
  text: string;
}

const Row = ({ icon, text }: RowPropsIface) => {
  return (
    <ValuePropRow
      overrideRootStyles={row}
      startIconColor={ExtendedPaletteColorName.BankingAccentLight}
      startElem='icon'
      startIcon={icon}
    >
      <Type.Text size='M' color={GoldGradient}>
        {text}
      </Type.Text>
    </ValuePropRow>
  );
};

interface PropsIface {
  style?: CSSInterpolation;
}

const ValuePropsCell = ({ style }: PropsIface) => {
  return (
    <Cell overrideRootStyles={[root, style]}>
      <Row icon='Cash24' text='3% cash back on all categories' />
      <Divider />
      <Row icon='Person24' text='No authorized user fee' />
      <Divider />
      <Row icon='Gift24' text='No annual fee with Gold membership' />
    </Cell>
  );
};

const root = css`
  padding: 0px;
`;

const row = css`
  text-align: left;
  padding: 8px 24px;
`;

export default ValuePropsCell;
